import { Component } from "react";
import CenterBox from "../CenterBox";

import "./CountdownOverlay.css";

class CountdownOverlay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secondsRemaining: this.calculateSecondsRemaining()
        };
        this.tick = this.tick.bind(this);
    }

    calculateSecondsRemaining() {
        if (!this.props.startsAt) return 0;
        const remaining = Math.ceil((this.props.startsAt - Date.now()) / 1000);
        return Math.max(0, remaining);
    }

    componentDidMount() {
        this.timer = setInterval(this.tick, 100);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    tick() {
        const secondsRemaining = this.calculateSecondsRemaining();
        this.setState({ secondsRemaining });

        if (secondsRemaining <= 0) {
            clearInterval(this.timer);
            if (this.props.onComplete) {
                this.props.onComplete();
            }
        }
    }

    render() {
        const { secondsRemaining } = this.state;

        return (
            <CenterBox logo {...this.props}>
                <div className="countdown-overlay">
                    <div className="countdown-label">Starting in</div>
                    <div className="countdown-number">{secondsRemaining}</div>
                </div>
            </CenterBox>
        );
    }
}

export default CountdownOverlay;
